import { automaticThoughtIdList } from "api/conceptApi";
import { isDev } from "config";
import { ProgramContentType } from "data/BlockComponent";
import { ProgramType, TaskMetaData } from "data/programData";
import { Content_0_0_A } from "data/task/0-0-A2";
import { Content_0_1_A } from "data/task/0-1-A";
import { Content_0_2_A } from "data/task/0-2-A";
import { Content_0_3_A } from "data/task/0-3-A";
import { Content_1_1_A } from "data/task/1-1-A2";
import { Content_1_2_A } from "data/task/1-2-A";
import { Content_1_3_A } from "data/task/1-3-A";
import { Content_1_4_A } from "data/task/1-4-A";
import { Content_2_1_A } from "data/task/2-1-A";
import { Content_2_2_T } from "data/task/2-2-T";
import { Content_3_1_A } from "data/task/3-1-A";
import { Content_3_2_A } from "data/task/3-2-A";
import { Content_3_3_A } from "data/task/3-3-A";
import { Content_4_1_A } from "data/task/4-1-A";
import { Content_4_2_A } from "data/task/4-2-A";
import { Content_4_3_1_A } from "data/task/4-3-1-A";
import { Content_4_3_2_A } from "data/task/4-3-2-A";
import { Content_4_4_1_A } from "data/task/4-4-1-A";
import { Content_4_4_2_A } from "data/task/4-4-2-A";
import { Content_4_4_3_A } from "data/task/4-4-3-A";
import { Content_4_4_4_A } from "data/task/4-4-4-A";
import { Content_4_4_5_A } from "data/task/4-4-5-A";
import { Content_4_4_6_A } from "data/task/4-4-6-A";
import { Content_4_5_1_A } from "data/task/4-5-1-A";
import { Content_4_5_2_A } from "data/task/4-5-2-A";
import { Content_4_5_3_A } from "data/task/4-5-3-A";
import { Content_4_5_4_A } from "data/task/4-5-4-A";
import { Content_4_5_5_A } from "data/task/4-5-5-A";
import { Content_4_5_6_A } from "data/task/4-5-6-A";
import { Content_5_1_A } from "data/task/5-1-A";
import { Content_5_2_A } from "data/task/5-2-A";
import { Content_5_3_A } from "data/task/5-3-A";
import { Content_5_4_A } from "data/task/5-4-A";
import { Content_5_5_A } from "data/task/5-5-A";
import { Content_6_1_A } from "data/task/6-1-A";
import { Content_6_2_A } from "data/task/6-2-A";
import { Content_6_3_A } from "data/task/6-3-A";
import { Content_6_4_A } from "data/task/6-4-A";
import { Content_6_5_A } from "data/task/6-5-A";
import { Content_6_6_A } from "data/task/6-6-A";
import { Content_6_7_A } from "data/task/6-7-A";

import { Content_6_8_A } from "data/task/6-8-A";
import { Content_6_9_A } from "data/task/6-9-A";

import { Content_6_97_A } from "data/task/6-97-A";
import { Content_6_98_A } from "data/task/6-98-A";
import { Content_6_99_A } from "data/task/6-99-A";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { patientAtom } from "recoil/patientAtom";
import { userAtom } from "recoil/userAtom";
import { ThoughtmapStateType } from "./getThoughtMapState";

export default function useGetProgramData(taskId: string) {
  const userState = useRecoilValue(userAtom);
  const patientState = useRecoilValue(patientAtom);

  const isCoach = userState?.role !== "patient";

  const hasPraised = isCoach ? patientState?.hasPraised : userState?.hasPraised;

  const programData: ProgramType[] = [
    //0-0-A
    {
      taskId: "0-0-A",
      content: Content_0_0_A(userState?.isAiCoachProduct || false),
    },
    //0-1-A
    {
      taskId: "0-1-A",
      content: Content_0_1_A,
    },
    //0-2-A
    {
      taskId: "0-2-A",
      content: Content_0_2_A,
    },
    //0-3-A
    {
      taskId: "0-3-A",
      content: Content_0_3_A(!hasPraised),
    },
    //1-1-A
    {
      taskId: "1-1-A",
      content: Content_1_1_A,
    },
    //1-2-A
    {
      taskId: "1-2-A",
      content: Content_1_2_A,
    },
    //1-3-A
    {
      taskId: "1-3-A",
      content: Content_1_3_A,
    },
    //1-4-A
    {
      taskId: "1-4-A",
      content: Content_1_4_A,
    },
    //2-1-A
    {
      taskId: "2-1-A",
      content: Content_2_1_A,
    },
    //2-2-T
    {
      taskId: "2-2-T",
      content: Content_2_2_T,
    },
    //3-1-A
    {
      taskId: "3-1-A",
      content: Content_3_1_A,
    },
    //3-2-A
    {
      taskId: "3-2-A",
      content: Content_3_2_A,
    },
    //3-3-A
    ...automaticThoughtIdList.map((each) => ({
      taskId: `3-3-A_${each}`,
      content: Content_3_3_A(each),
    })),
    //4-1-A
    {
      taskId: "4-1-A",
      content: Content_4_1_A,
    },
    //4-2-A
    ...automaticThoughtIdList.map((each) => ({
      taskId: `4-2-A_${each}`,
      content: Content_4_2_A(each),
    })),
    //4-3-1-A
    {
      taskId: `4-3-1-A`,
      content: Content_4_3_1_A,
    },
    //4-3-2-A
    {
      taskId: `4-3-2-A`,
      content: Content_4_3_2_A,
    },
    //4-4-1-A
    {
      taskId: `4-4-1-A`,
      content: Content_4_4_1_A,
    },
    //4-4-2-A
    {
      taskId: `4-4-2-A`,
      content: Content_4_4_2_A,
    },
    //4-4-3-A
    {
      taskId: `4-4-3-A`,
      content: Content_4_4_3_A,
    },
    //4-4-4-A
    {
      taskId: `4-4-4-A`,
      content: Content_4_4_4_A,
    },
    //4-4-5-A
    {
      taskId: `4-4-5-A`,
      content: Content_4_4_5_A,
    },
    //4-4-6-A
    {
      taskId: `4-4-6-A`,
      content: Content_4_4_6_A,
    },
    //4-5-1-A
    ...automaticThoughtIdList.map((each) => ({
      taskId: `4-5-1-A_${each}`,
      content: Content_4_5_1_A(each),
    })),
    //4-5-2-A
    ...automaticThoughtIdList.map((each) => ({
      taskId: `4-5-2-A_${each}`,
      content: Content_4_5_2_A(each),
    })),
    //4-5-3-A
    ...automaticThoughtIdList.map((each) => ({
      taskId: `4-5-3-A_${each}`,
      content: Content_4_5_3_A(each),
    })),
    //4-5-4-A
    ...automaticThoughtIdList.map((each) => ({
      taskId: `4-5-4-A_${each}`,
      content: Content_4_5_4_A(each),
    })),
    //4-5-5-A
    ...automaticThoughtIdList.map((each) => ({
      taskId: `4-5-5-A_${each}`,
      content: Content_4_5_5_A(each),
    })),
    //4-5-6-A
    ...automaticThoughtIdList.map((each) => ({
      taskId: `4-5-6-A_${each}`,
      content: Content_4_5_6_A(each),
    })),
    //5-1-A
    {
      taskId: `5-1-A`,
      content: Content_5_1_A,
    },
    //5-2-A
    {
      taskId: `5-2-A`,
      content: Content_5_2_A,
    },
    //5-3-A
    ...automaticThoughtIdList.map((each) => ({
      taskId: `5-3-A_${each}`,
      content: Content_5_3_A(each),
    })),
    //5-4-A
    ...automaticThoughtIdList.map((each) => ({
      taskId: `5-4-A_${each}`,
      content: Content_5_4_A(each),
    })),
    //5-5-A
    ...automaticThoughtIdList.map((each) => ({
      taskId: `5-5-A_${each}`,
      content: Content_5_5_A(each),
    })),
    //6-1-A
    {
      taskId: `6-1-A`,
      content: Content_6_1_A,
    },
    //6-2-A
    {
      taskId: `6-2-A`,
      content: Content_6_2_A,
    },
    //6-3-A
    {
      taskId: `6-3-A`,
      content: Content_6_3_A,
    },
    //6-4-A
    {
      taskId: `6-4-A`,
      content: Content_6_4_A,
    },
    //6-5-A
    {
      taskId: `6-5-A`,
      content: Content_6_5_A(false, false, false),
    },
    //6-6-A
    {
      taskId: `6-6-A`,
      content: Content_6_6_A,
    },
    //6-7-A
    {
      taskId: `6-7-A`,
      content: Content_6_7_A,
    },
    //6-8-A
    {
      taskId: `6-8-A`,
      content: Content_6_8_A,
    },
    //6-9-A
    {
      taskId: `6-9-A`,
      // content: Content_6_9_A([], []) as ProgramContentType[],
      content: [],
    },
    //6-10-A
    {
      taskId: `6-10-A`,
      content: [],
    },

    //6-97-A
    {
      taskId: `6-97-A`,
      content: Content_6_97_A,
    },
    //6-98-A
    {
      taskId: `6-98-A`,
      content: Content_6_98_A,
    },
    //6-99-A
    {
      taskId: `6-99-A`,
      content: Content_6_99_A,
    },
  ];

  return programData.find((element) => element.taskId === taskId);
}
